module.exports = __webpack_public_path__ + "img/logo1.b8d5e407.png";